function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import AttributeTracker from './AttributeTracker';
import BindingManager from './BindingManager';
import Component from './Component';
import { documentLoaded, beforeDocumentUnload } from './documentLifecycle';
import getFallbackConsumer from './getFallbackConsumer';

var Client = /*#__PURE__*/function () {
  function Client() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Client);

    Object.assign(this, Client.defaultOptions, options);
    this._componentSelector = "[".concat(this.keyAttribute, "][").concat(this.stateAttribute, "]");
    this._componentTracker = new AttributeTracker(this.keyAttribute, function (element) {
      return element.hasAttribute(_this.stateAttribute) // ensure matches selector
      ? new Component(_this, element) : null;
    });
    this._motionTracker = new AttributeTracker(this.motionAttribute, function (element) {
      return new BindingManager(_this, element);
    });
    documentLoaded.then(function () {
      // avoid mutations while loading the document
      _this._componentTracker.attachRoot(_this.root);

      _this._motionTracker.attachRoot(_this.root);
    });

    if (this.shutdownBeforeUnload) {
      beforeDocumentUnload.then(function () {
        return _this.shutdown();
      });
    }
  }

  _createClass(Client, [{
    key: "log",
    value: function log() {
      if (this.logging) {
        var _console;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        (_console = console).log.apply(_console, ['[Motion]'].concat(args));
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent(element) {
      return this._componentTracker.getManager(element.closest(this._componentSelector));
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      this._componentTracker.shutdown();

      this._motionTracker.shutdown();
    }
  }]);

  return Client;
}();

export { Client as default };
Client.defaultOptions = {
  get consumer() {
    return getFallbackConsumer();
  },

  getExtraDataForEvent: function getExtraDataForEvent(_event) {// noop
  },
  logging: false,
  root: document,
  shutdownBeforeUnload: true,
  keyAttribute: 'data-motion-key',
  stateAttribute: 'data-motion-state',
  motionAttribute: 'data-motion'
};